import { v4 as uuid } from 'uuid';

import type { Step } from '@sb/remote-control/types';

import { getStepKindInfo } from './stepKindInfo';

interface ConvertStepSummaryOptions {
  /**
   * In some cases we need to generate a new stepID instead of using the
   * current one (i.e. when using a routine template).
   */
  shouldReplaceStepID?: boolean;
}

export const convertStepSummary = (
  steps: Step.Summary[],
  options?: ConvertStepSummaryOptions,
): Step.ConvertedSummary[] => {
  let stepPosition = 0;

  const mapSteps = (
    substeps: Step.Summary[],
    parentSteps: Step.ParentStep[],
  ): Step.ConvertedSummary[] => {
    let siblingPosition = 0;

    return substeps.map((step) => {
      stepPosition += 1;

      const stepID = options?.shouldReplaceStepID ? uuid() : step.id;

      /**
       * Set the current step as the parent one when calling
       * the recursive `mapSteps` function.
       */
      const parentStepSummary: Step.ParentStep = {
        id: stepID,
        stepKind: step.stepKind,
      };

      const convertedStep: Step.ConvertedSummary = {
        description: step.description,
        id: stepID,
        name: getStepKindInfo(step.stepKind).name,
        parentSteps,
        stepKind: step.stepKind,
        stepPosition,
        siblingPosition,
        steps: mapSteps(step.steps ?? [], [...parentSteps, parentStepSummary]),
      };

      siblingPosition += 1;

      return convertedStep;
    });
  };

  return mapSteps(steps, []);
};
